// ==========================================================================
// Squarebit Store - Copyright (c) 2026 Squarebit LLC. All rights reserved.
// Proprietary and confidential. Not for redistribution.
// ==========================================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { DocH2, DocH3, DocP, DocList } from './doc-bits.component';

const SbFrameworkDocsLanding: React.FC = () => (
  <article className="font-body text-content-primary">
    <DocH2 id="overview">Squarebit Framework</DocH2>
    <DocP>
      A rigging toolset for Maya: the deformer and pose space deformer tools, a
      library of runnable rig templates, and the libraries they are built on.
    </DocP>

    <DocH3 id="where-to-start">Where to start</DocH3>
    <DocList
      items={[
        <>
          <Link className="text-blue underline" to="/sbframework/docs/install">
            Install and license
          </Link>{' '}
          getting the module in place and activated.
        </>,
        <>
          <Link className="text-blue underline" to="/sbframework/docs/templates">
            Templates and builds
          </Link>{' '}
          what is in the library and what happens when a build runs.
        </>,
        <>
          <Link className="text-blue underline" to="/sbframework/docs/nxt">
            nxt
          </Link>{' '}
          the graph editor the templates are authored and built in.
        </>,
        <>
          <Link className="text-blue underline" to="/sbframework/docs/api/core">
            API reference
          </Link>{' '}
          generated from the build you have, for core, mix and sbgui.
        </>
      ]}
    />

    <DocH3 id="what-ships">What ships in it</DocH3>
    <DocList
      items={[
        <>
          <strong>mix</strong> the deformer and PSD toolset, and its interfaces.
        </>,
        <>
          <strong>core</strong> scene, deformer and pose interpolator libraries.
        </>,
        <>
          <strong>sbgui</strong> the widget library the interfaces are built
          from.
        </>,
        <>
          <strong>templates</strong> the rig template library, for Maya and
          Blender.
        </>,
        <>
          <strong>Shape Inverter</strong> compiled for every Maya version the
          framework supports.
        </>
      ]}
    />
  </article>
);

export default SbFrameworkDocsLanding;
